var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-message',{attrs:{"message":_vm.message}},[_c('div',{staticClass:"text-message"},[_vm._v(" 网络异常！ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }